module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "py4 px3",
    attrs: {
      "id": "materials"
    }
  }, [_c('h1', {
    staticClass: "m0 mb3 center",
    class: {
      'mb3': !_vm.standalone, 'mb4': _vm.standalone
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap justify-center"
  }, _vm._l((_vm.articles), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "flex flex-column justify-between m2"
    }, [_c('header', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Article',
          params: {
            lang: item.language.code,
            slug: item.slug,
            oid: item.id
          }
        }
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo($event, 'app')
        }
      }
    }, [(item.cover) ? _c('div', {
      staticClass: "cover",
      style: ('background-image: url(' + _vm.getContentAPIBase() + item.cover.url + '); background-size: cover; background-position: center center;'),
      attrs: {
        "id": 'cover_' + item.id
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "p2"
    }, [_c('h2', {
      staticClass: "h3 m0"
    }, [_c('router-link', {
      staticClass: "black-blue-link",
      attrs: {
        "id": 'title_link_' + item.id,
        "to": {
          name: 'Article',
          params: {
            lang: item.language.code,
            slug: item.slug,
            oid: item.id
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      },
      on: {
        "click": function($event) {
          return _vm.scrollTo($event, 'app')
        }
      }
    })], 1)])], 1), _vm._v(" "), _c('footer', {
      staticClass: "p2"
    }, [_c('div', {
      staticClass: "dark-grey h6 flex items-center"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(item.createdAt)))])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43aa4714","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticlesList.vue
// module id = 122
// module chunks = 0